import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_NEW_DAILY_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const NewDailyReports = lazy(() =>
  import('../../../screens/NewDailyReports')
    .then(module => ({default: module.NewDailyReports})));

const NewDailyReportsNavigation = [
  {
    path: ROUTE_NEW_DAILY_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <NewDailyReports />
      </Suspense>
    ),
  },
];

export default NewDailyReportsNavigation;
